// extracted by mini-css-extract-plugin
export default {"groupPlans":"group-plans-module--group-plans--7bcc0","mainHeader":"group-plans-module--main-header--4c19a","faq":"group-plans-module--faq--c290f"};